import { AddressModelMf, InfoMf, PackageMf, RmaDeletedMf, ShippingMf, UserMf } from 'models/rmamanufatura/rmaModel';

export class ErrorsMsgDetailsRmaModelMf {
    shipping: string;
    shippingDate: string;
    problem: string;
    problemDescription: string;
    typeService: string;
    problemDescriptionAcessory: string;
    modelEquipmentAcessory: string;
    typeServiceAcessory: string;

    constructor() {
        this.shipping = '';
        this.shippingDate = '';
        this.problem = '';
        this.problemDescription = '';
        this.typeService = '';
        this.problemDescriptionAcessory = '';
        this.modelEquipmentAcessory = '';
        this.typeServiceAcessory = '';
    }
}

export class ErrorsMsgModelMf {
    cep: string;
    state: string;
    city: string;
    neighborhood: string;
    street: string;
    number: string;
    InvoiceCnpj: string;
    ShippingDate: string;
    Erro: boolean;
    zipCode: string | undefined;

    constructor() {
        this.cep = '';
        this.state = '';
        this.city = '';
        this.neighborhood = '';
        this.street = '';
        this.number = '';
        this.InvoiceCnpj = '';
        this.ShippingDate = '';
        this.Erro = true;
    }
}

export type ValidateCompanyEmailFieldsMf = { companyName: string; phone?: string; email: string; cnpj: string; idSap?: string, Pv?: string };
export type EmailServiceTypeMf<T = any> = {
    Body: string;
    Subject: string;
    ToEmail: string;
    NewCompany: Boolean;
    Fields: T;
};

export type BadgeColorsMf = { [color in 'green' | 'yellow' | 'blue' | 'red' | 'orange' | 'grey']?: number[] };
export const rmaTypeColorsMf: BadgeColorsMf = { green: [1, 2, 3, 5], blue: [4] };
export const rmaStatusColorsMf: BadgeColorsMf = {
    yellow: [1, 2, 5, 20, 23, 51, 52, 53, 54, 55],
    blue: [3, 7, 8, 9, 16, 17, 18, 19, 21, 22],
    red: [11, 12, 13, 14, 24, 25]
};

export type AddItemInCartModelMf = {
    Id: any;
    PartNumberModel: any;
    SerialNumber: any;
    PartNumberType: any;
    //TypeId: any;
    ProblemLocationId: any;
    ProblemTypeId: any;
    ProblemDescription: any;
    Indice: any;
    Selected: any;
    FlagServiceAuthorized: any;
    IsEOS: any;
};

export type RmaChatTableMf = ChatTableMf & { rmaId: number };
export type SparePartsChatTableMf = ChatTableMf & { orderId: number };
export type ChatTableMf = {
    id?: number;
    ssoId: string;
    companyId: number;
    itWasReadByCustomer: boolean;
    itWasReadByAdmin: boolean;
    message: string;
    userName: string;
    createdAt?: Date;
    orderId?: number;
    rmaId?: number;
    sparePartsId?: number;
    roleId?: number;
    enable: boolean
};

export type CreatNewRmaModelMf = {
    id: number;
    rmaItems?: RmaItemsMf[];
    observacao?: string;
    ssoId: string;
    cnpjCompany: string;
    status: number;
    createdAt: Date;
    phoneResponsible: string;
    nameResponsible: string;
};

export type EventoTransicao = {
    id: number;
    rmaid: number;
    status: string;
    observacao: string;
    ssoId: string;
    pageIdentifier: string;
    updatedAt: Date;
    situacao: string;
}

export class rmaShipmentMf {
    id?: any;
    hight?: string;
    width?: string;
    length?: string;
    weight?: string;
    shipmentDate?: string;
    address?: addressMf;
    rmaId?: any;
}

export type addressMf = {
    id?: any;
    cep?: string;
    state?: string;
    city?: string;
    neighborhood?: string;
    street?: string;
    number?: any;
    complement?: string;
};

export type problemLocationMf = {
    id?: any;
    name?: string;
};

export type problemTypeMf = {
    id?: any;
    name?: string;
};

export type serviceTypeMf = {
    id?: any;
    name?: string;
};

export class rmaItemsMf {
    id?: any;
    approved?: boolean;
    model?: string;
    rmaId?: number;
    rmaItemsEquipment?: rmaItemsEquipmentMf;
    rmaItemsAccessories?: rmaItemsEquipmentMf;
    serviceType?: serviceTypeMf;
    serviceTypeId?: number | null;
}

export type rmaItemsEquipmentMf = {
    id?: any;
    rmaItemsManufacturingId?: any;
    problemLocation?: problemLocationMf;
    problemLocationId?: any;
    problemType?: problemTypeMf;
    problemTypeId?: any;
    problemTypeDescription?: string | null;
    problemDescription?: any;
    serialNumber?: string;
    quantity?: any;
    volumeType?: any;
    gbe?: any;
    nfHoneywell?: any;
};

export type rmaCartManufacturingMf = {
    id?: any;
    volumeType?: any;
    identifiedTime?: any;
    nfHoneywell?: any;
    quantity: any;
    gbe?: any;
};

export type rmaItemsAccessoriesMf = {
    id?: any;
    problemDescription?: any;
};

export type RmaItemsMf = {
    id: number;
    model: string;
    rmaItemsEquipment: {
        problemLocation: serviceTypeMf;
        problemType: InfoMf;
        serialNumber: string;
        problemLocationId: number;
        problemTypeDescription?: string;
    };
    rmaCartManufacturing: {
        volumeType?: number;
        identifiedTime?: number;
        nfHoneywell?: string;
        quantity?: string;
        gbe?: string;
    }
    //approved?: boolean;
};
export class rmaItemsEquipmentModelMf {
    serialNumber?: string | null;
    problemLocationId?: number | null;
    problemTypeId?: number | null;
    problemTypeDescription?: string | null;
    problemDescription?: string | null;

    constructor() {
        this.serialNumber = null;
        this.problemDescription = null;
        this.problemLocationId = null;
        this.problemTypeId = null;
    }
}

export class rmaCartManufacturingModelMf {
    volumeType?: number | null;
    identifiedTime?: number | null;
    nfHoneywell?: string | null;
    quantity?: string | null;
    gbe?: string | null;

    constructor() {
        this.volumeType = null;
        this.identifiedTime = null;
        this.nfHoneywell = null;
        this.quantity = null;
        this.gbe = null;
    }
}
export class rmaItemsAccessoriesModelMf {
    problemDescription?: string | null;

    constructor() {
        this.problemDescription = null;
    }
}

export type ItemsCartMf = {
    id?: any;
    partNumber?: string;
    rmaItemsAccessories?: rmaItemsEquipmentMf;
    rmaItemsEquipment?: rmaItemsEquipmentMf;
    serviceType?: serviceTypeMf;
    serviceTypeId?: any;
    user?: {};
    ssoId?: string;
};

export type CreatNewRmaModelCAMf = {
    Accessories?: any;
    DiscountCouponId?: any;
    DiscountCouponIsValid?: any;
    DiscountCouponNumber: any;
    DiscountCouponPercent?: any;
    IsEOS: any;
    InvoiceCnpj: any;
    InvoiceValues: any;
    newRmaItemCart: RmaItemsCAMf[];
    NumberNfe: any;
    Obs?: any;
    ShipmentRequested: number;
    ShipmentShipping: ShipmentShippingMf;
    ShippingAddress: ShippingAddressMf;
    ShippingDate?: any;
    TypeId: any;
    UserId: any;
};

export type ResultMf = {
    TypeId?: any;
    Accessories?: any;
    BilTo?: BillToMf;
    CreatedAt?: any;
    Id?: any;
    Obs?: any;
    QtdItems?: any;
    RmaItems: RmaItemsCAMf[];
    ShipTo?: ShiptoMf;
    ShippingDate?: any;
    SoldTo?: SoldToMf;
    StatusId?: any;
    SupportLevelId?: any;
    UpdatedAt?: any;
    UserId?: any;
};
export type RmaItemsCAMf = {
    CreatedAt?: Date;
    DBR?: boolean;
    DeliveryDate?: Date;
    DockReceiptDate?: Date;
    ErrorDetails?: any;
    Id?: any;
    model?: any;
    NPF?: boolean;
    PartNumber?: any;
    PartNumberModel?: any;
    PcbReplaced?: boolean;
    ProblemDescription?: any;
    ProblemLocationId?: any;
    ProblemTypeId?: any;
    ReplacementSerialNumber?: any;
    ReturnShippingLabel?: any;
    RmaId?: any;
    SerialNumber?: any;
    ServicePerformed?: any;
    Shipment?: any;
    Status?: any;
    StatusId?: any;
    UpdatedAt?: any;
    UserId?: any;
};

//Criei esse modelo de teste para ficar parecido com o que é enviado para o back em Homolog
export type CreatNewRmaModelCATestMf = {
    Accessories?: any;
    BillTo?: BillToMf;
    DiscountCouponId?: any;
    DiscountCouponIsValid?: any;
    DiscountCouponNumber?: any;
    DiscountCouponPercent?: any;
    InvoiceCnpj?: any;
    InvoicesValue?: any;
    ItemsCart?: [];
    NumberNfe?: any;
    Obs?: any;
    ShipTo?: ShiptoMf;
    ShipmentRequested?: any;
    ShippingDate?: any;
    SoldTo?: SoldToMf;
    TypeId?: any;
    steppers?: {};
};

export type BillToMf = {
    City?: string;
    Complement?: any;
    Contact?: string;
    Country?: string;
    Id?: number;
    Name?: string;
    Neighborhood?: string;
    Number?: string;
    State?: string;
    Street?: string;
    ZipCode?: string;
};

export type SoldToMf = {
    City?: string;
    Complement?: any;
    Contact?: string;
    Country?: string;
    Id?: number;
    Name?: string;
    Neighborhood?: string;
    Number?: string;
    State?: string;
    Street?: string;
    ZipCode?: string;
};

export type ShiptoMf = {
    City?: string;
    Complement?: any;
    Contact?: string;
    Country?: string;
    Id?: number;
    Name?: string;
    Neighborhood?: string;
    Number?: string;
    State?: string;
    Street?: string;
    ZipCode?: string;
};

export type ShippingAddressMf = {
    Cep: any;
    State: any;
    City: any;
    Neighborhood: any;
    Street: any;
    Number: any;
    Complement: any;
    ShippingDate: any;
};

export type ShipmentShippingMf = {
    ResponsibleName: any;
    ResponsiblePhone: any;
    Height: any;
    Width: any;
    Length: any;
    Weight: any;
    Type: any;
    Quantity: any;
    BusinessHours: any;
    CollectionRequestDate: any;
};